import { createRoute } from '@tanstack/react-router';
import {
  EnterpriseRegisterRoute,
  GuestLoginRoute,
  PartnerRegisterRoute,
  RegisterRoute,
} from '../common';
import { guestRoute } from '../layouts';

// Guest-only pages: a logged-in user is bounced off them by `guestRoute`. Keep `GUEST_ONLY_PATHS`
// (auth/guest-paths.ts) in step with the paths below - it is what stops a `?from=` sending the
// user straight back to one of them.

export const loginRoute = createRoute({
  getParentRoute: () => guestRoute,
  path: '/login',
  component: GuestLoginRoute,
  validateSearch: (search: Record<string, unknown>) => ({
    from: typeof search.from === 'string' ? search.from : undefined,
  }),
  staticData: { title: 'auth.login' },
});

// Guest-only: register a new account.
export const registerRoute = createRoute({
  getParentRoute: () => guestRoute,
  path: '/register',
  component: RegisterRoute,
  staticData: { title: 'auth.register' },
});

export const partnerRegisterRoute = createRoute({
  getParentRoute: () => guestRoute,
  path: '/partner-register',
  component: PartnerRegisterRoute,
  staticData: { title: 'auth.partner_register' },
});

export const enterpriseRegisterRoute = createRoute({
  getParentRoute: () => guestRoute,
  path: '/go-enterprise',
  component: EnterpriseRegisterRoute,
  staticData: { title: 'auth.enterprise_register' },
});
